import type { planEnrollmentApiSpec } from "@wingspanhq/wingspan-api-types";
import { CancellationStepContentProps } from "./types";
import {
  AOICancellationAreYouSureInfo,
  AOICancellationConfirmationInfo,
  AOICancellationContinuingInfo
} from "./AOI";
import {
  PGLICancellationAreYouSureInfo,
  PGLICancellationConfirmationInfo,
  PGLICancellationContinuingInfo
} from "./PGLI";

type IPlanType = planEnrollmentApiSpec.PlanEnrollment["planType"];

export const AreYouSureInfo: React.FC<CancellationStepContentProps> = ({
  planType
}) => {
  const blocks: Record<IPlanType, React.FC<CancellationStepContentProps>> = {
    MeridioHealth: () => null,
    WingspanOccupationalAccidentInsurance: AOICancellationAreYouSureInfo,
    WingspanProfessionalLiabilityAndGeneralLiabilityInsurance:
      PGLICancellationAreYouSureInfo
  };

  const Component = blocks[planType];

  return <Component planType={planType} />;
};

export const ContinueWithCancellationInfo: React.FC<
  CancellationStepContentProps
> = ({ planType }) => {
  const blocks: Record<IPlanType, React.FC<CancellationStepContentProps>> = {
    MeridioHealth: () => null,
    WingspanOccupationalAccidentInsurance: AOICancellationContinuingInfo,
    WingspanProfessionalLiabilityAndGeneralLiabilityInsurance:
      PGLICancellationContinuingInfo
  };

  const Component = blocks[planType];

  return <Component planType={planType} />;
};

export const ConfirmCancellationInfo: React.FC<
  CancellationStepContentProps
> = ({ planType }) => {
  const blocks: Record<IPlanType, React.FC<CancellationStepContentProps>> = {
    MeridioHealth: () => null,
    WingspanOccupationalAccidentInsurance: AOICancellationConfirmationInfo,
    WingspanProfessionalLiabilityAndGeneralLiabilityInsurance:
      PGLICancellationConfirmationInfo
  };

  const Component = blocks[planType];

  return <Component planType={planType} />;
};
